<script setup lang="ts">
import type { SightlineNumberCell } from "@/backend/natsstubs/sightline/models";

defineProps<{ cell: SightlineNumberCell }>();
</script>

<template>
  <span class="number">{{ cell.value }}</span>
</template>

<style scoped lang="scss">
@use "@/styles/mixins/typography";

.number {
  @include typography.small("regular");

  font-variant-numeric: tabular-nums;
}
</style>
